import { useEffect, useState } from "react"
import { getInventarioCabById} from "../../services/InventariosCabServices";
import { postRealizarInventario } from "../../services/ArticulosDepositoServices";
import { getInventariosDetPanel } from "../../services/InventariosDetServices";
import { InventariosCabFormContext } from "./InventariosCabContext"
import { useNavigate, useParams } from 'react-router-dom';

export const InventariosCabFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams();
    const [detalleInventarioData, setDetalleInventarioData] = useState([]);

    useEffect(() => {
        if (id) getInventarioCabByIdData(id)
    }, [])

    const getInventarioCabByIdData = async (id) => {
        let res = await getInventarioCabById(id)
        if (res) setReport(res)
    }

   const postInventarioCabData = async () => {
    if (!Array.isArray(detalleInventarioData) || detalleInventarioData.length === 0) {
        console.warn("No hay datos de inventario para enviar.");
        return;
    }

    const data = {
        "depo_id": 1,
        articulos: detalleInventarioData.map(({ id, descripcion, ...item }) => ({
            "art_id": item.ajud_art_id,
            "cantidad": item.ajud_stockreelevado,
            "ajud_obs": item.ajud_obs,
        }))
    };

    try {
        
        const res = await postRealizarInventario(data);
        navigate("/inventarios");
    } catch (error) {
        console.error("Error al grabar inventario:", error);
    }
};

    const addItemToArray = (item) => {
        setDetalleInventarioData((prevData) => [...prevData, item]);
    };

    const getItemFromArrayById = (id) => {
        // Convertimos ambos a string para asegurarnos de que la comparación sea consistente
        const item = detalleInventarioData.find((item) => String(item.id) === String(id));

        return item || null; // Si no encuentra el elemento, devuelve null
    };


    const updateItemFromArray = (id, updatedFields) => {
        setDetalleInventarioData((prevState) =>
            prevState.map(item =>
                item.ajd_id === id
                    ? { ...item, ...updatedFields }
                    : item
            )
        );
    };

    const removeItemFromArray = (id) => {
        setDetalleInventarioData((prevState) =>
            prevState.filter(item => item.ajd_id !== id)
        );
    };

    const clearArray = () => {
        setDetalleInventarioData([]); // Establece el estado a un array vacío
    };
    return <InventariosCabFormContext.Provider value={{
        report,
        postInventarioCabData,
        detalleInventarioData,
        addItemToArray,
        getItemFromArrayById,
        updateItemFromArray,
        removeItemFromArray,
        clearArray
    }} >
        {children}
    </InventariosCabFormContext.Provider>
}